import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import {
  KeyValue,
  PartnerBetreuer,
  PayloadAnalyzeResultList,
  PayloadArchivDocumentNotizList,
  PayloadBoolean,
  PayloadElekkomTokenResultList,
  PayloadKeyValueStringList,
  PayloadString
} from '@pezi/entities';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RestService {

  protected baseUrl = environment.serverUrl;

  protected httpOptions = {
    headers:         new HttpHeaders({
      'Content-Type': 'application/json'
    }),
    withCredentials: true
  };

  constructor(protected http: HttpClient) {}

  public getKeyValueAsQueryParams<T>(obj: KeyValue<string, any>[]): HttpParams {
    let params = new HttpParams();
    obj.forEach(v => {
      if (v && v.value) {
        params = params.set(v.key, v.value);
      }
    });
    return params;
  }

  public uploadFile(body: Blob, filename: string): Observable<PayloadString> {
    const formData: FormData = new FormData();
    formData.append('file', body, filename);
    return this.http
      .post<PayloadString>(this.baseUrl + '/file/upload', formData, fileUploadOptions);
  }

  public downloadDocument(docId: string): Observable<HttpResponse<Blob>> {

    return this.http
      .get<Blob>(`${this.baseUrl}/documents/download`,
        {
          ...this.httpOptions,
          params:       {docId},
          observe:      'response',
          responseType: 'blob' as 'json'
        });
  }

  public sendClientError(errorReport: ErrorReportDto): Observable<PayloadString> {
    return this.http
      .post<PayloadString>(this.baseUrl + '/report/error', errorReport, this.httpOptions);
  }

  public analyzeValue(nr: string): Observable<PayloadAnalyzeResultList> {
    const params = this.getKeyValueAsQueryParams([
      {
        key:   'value',
        value: nr
      }
    ]);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadAnalyzeResultList>(this.baseUrl + '/analyze', options);
  }

  public getO30Url(): Observable<PayloadString> {
    return this.http
      .get<PayloadString>(this.baseUrl + '/o30url', this.httpOptions);
  }

  public getGoogleApiIsEnabled(): Observable<PayloadBoolean> {
    return this.http
      .get<PayloadBoolean>(this.baseUrl + '/googleapiisenabled', this.httpOptions);
  }

  public getGooglePlacesApiKey(): Observable<PayloadString> {
    return this.http
      .get<PayloadString>(this.baseUrl + '/googleplacesapikey', this.httpOptions);
  }

  public getDocumentNotiz(docId: string): Observable<PayloadArchivDocumentNotizList> {
    const params = this.getKeyValueAsQueryParams([
      {
        key:   'docId',
        value: docId
      }
    ]);
    const options = Object.assign({}, this.httpOptions,
      {params});
    return this.http
      .get<PayloadArchivDocumentNotizList>(this.baseUrl + '/documents/notiz', options);
  }

  public selectBetreuer(body: PartnerBetreuer): Observable<PayloadKeyValueStringList> {
    return this.http
      .put<PayloadKeyValueStringList>(
        this.baseUrl + '/selectbetreuer',
        body,
        this.httpOptions);
  }

  public getBenutzerElekkommOffen(): Observable<PayloadElekkomTokenResultList> {
    return this.http
      .get<PayloadElekkomTokenResultList>(this.baseUrl + '/elekkom/benutzer/offen', this.httpOptions);
  }

  public getHandbuch(): Observable<HttpResponse<Blob>> {

    return this.http
      .get<Blob>(`${this.baseUrl}/handbuch`,
        {
          ...this.httpOptions,
          observe:      'response',
          responseType: 'blob' as 'json'
        });
  }

}

export interface ErrorReportDto {
  stacktrace: string;
  url: string;
  clientVersion: string;
  deviceInfo: string
}

const fileUploadOptions = {
  withCredentials: true
};


